import { roundNumber } from "../../backend/before";

const VIEWED_PRODUCTS_KEY = 'vwdprd';
const updateProductView = (product) => {
    const products = JSON.parse(localStorage.getItem(VIEWED_PRODUCTS_KEY) || '[]');

    if (products.length === 0) {
        products.push(product);
        localStorage.setItem(VIEWED_PRODUCTS_KEY, JSON.stringify(products));
    } else {
        const updatedProducts = products.filter((p) => p.slug !== product.slug);
        updatedProducts.unshift(product);
        if (updatedProducts.length > 5) {
            updatedProducts.pop();
        }
        localStorage.setItem(VIEWED_PRODUCTS_KEY, JSON.stringify(updatedProducts));
    }
};

const ShopItemPage = () => {
    const main = document.getElementById('shop-view');
    if (!main) {
        return;
    }

    const element = {
        productPictureContainer: $('#product-pricing-image'),
        productPicture: $('#product-picture-active'),
        pictureGalleryItem: '.product-gallery__carousel-image',
        criteriaContent: $("#criteria-content"),
        criterias: [],
        productPrice: $("#product-price"),
        productPriceTax: $("#product-price-tax"),
        btnAddCart: $("#btn-add-cart"),
    };
    const criteriaIds = [];
    const criteriaValues = [];

    const criteriaCount = element.criteriaContent.data('count');

    for (let i = 1; i <= criteriaCount; i++) {
        element.criterias.push($(`#criteria-${i}`));
        criteriaValues.push(0);
    }

    const reloadSecondCriteria = (data) => {
        const selector = element.criterias[1];
        selector.empty().append(`<option value="">Choose an item</option>`);

        data.forEach((item) => {
            selector.append(`<option value="${item.id}">${item.name}</option>`);
        });
    };

    const setPrice = (price, noVat = false) => {
        const dineroInstance = Dinero({ amount: price });
        const dineroTax = dineroInstance.percentage(noVat ? 0 : 20);

        element.productPrice.text(`${dineroInstance.toFormat()}`);
        const dineroWithTax = dineroInstance.add(dineroTax);
        element.productPriceTax.text(`${dineroWithTax.toFormat()}`);
    };

    const isValidCriteriaValue = () => {
      let isValid = true;

      criteriaValues.forEach((val) => {
          isValid &= val > 0;
      });

      return isValid;
    };

    const buildQueryString = (criterias) => {
        let result = `criteria1=${criterias[0]}`;
        if (criteriaCount === 2) {
            result += `&criteria2=${criterias[1]}`;
        }

        return result;
    };

    const getCriteriaPricing = () => {
      const defaultPrice = +element.productPrice.data("value");
      const noVat = element.productPrice.data("novat");

      if (!isValidCriteriaValue()) {
          setPrice(defaultPrice, noVat);

          return;
      }

      const querystring = buildQueryString(criteriaValues);

      axios.get(`/products-pricing/filter?${querystring}`)
          .then((response) => {
              const pricing = response.data;

              if (pricing.picture) {
                  element.productPicture.attr('src', `/storage/${pricing.picture}`);
                  element.productPictureContainer.css('display', 'flex');
              } else {
                  const qstr = buildQueryString(criteriaIds);
                  axios.get(`/products-criterias/picture?${qstr}`)
                      .then((response) => {
                          if (response.data.picture) {
                              element.productPicture.attr('src', response.data.picture);
                              element.productPictureContainer.css('display', 'flex');
                          } else {
                              element.productPictureContainer.hide();
                          }
                      })
                      .catch(error => {
                          element.productPictureContainer.hide();
                      });
              }

              if (pricing && pricing.enabled && pricing.available) {
                  setPrice(roundNumber(pricing.price, 2), noVat);
                  element.btnAddCart.prop('disabled', false);
              } else {
                  element.productPrice.text('Not Available');
                  element.productPriceTax.text('N/A');
                  element.btnAddCart.prop('disabled', true);
              }
          });
    };

    const searchCriteriaPricing = () => {
        // If the first criteria is empty, we need to load all the values for criteria 2
        const index = criteriaValues[0] === 0 ? 1 : 0;
        const criteriaId = element.criterias[index].data('id');

        if (index === 1) {
            // Reset price
            const defaultPrice = +element.productPrice.data("value");
            const noVat = element.productPrice.data("novat");

            setPrice(defaultPrice, noVat);

            element.productPictureContainer.hide();
        }
        axios.get(`/products-pricing/search?criteriaId=${criteriaId}&criteriaValue=${criteriaValues[0]}`)
            .then((response) => {
                reloadSecondCriteria(response.data);
            }).catch((error) => {
                console.error(error);
            });
    };

    element.criterias.forEach((criteriaSelector, index) => {
        criteriaIds.push(criteriaSelector.data('id'));

        criteriaSelector.change(function () {
            const value = $(this).val();

            criteriaValues[index] = value ? +value : 0;

            if (index === 0 && criteriaCount === 2) {
                searchCriteriaPricing();
            } else {
                getCriteriaPricing();
            }
        });
    });

    const slug = _.last(location.pathname.split('/'));

    axios.get(`/products/${slug}`)
        .then((response) => {
            updateProductView(response.data);
        })
        .catch((error) => {
            console.error(error);
        });

    $('.product-gallery__carousel-item').on('click', function (e) {
        e.preventDefault();
        element.productPictureContainer.hide();
    });
};

$(() => {
    ShopItemPage();
});
